export var classListSupport = 'classList' in document.createElement('_');


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/classListSupport.js
// module id = 81
// module chunks = 0